import styled from '../../../../styles/styledComponents/themeComponents';

export const WidgetFormFooterStyle = styled.div`
  .button-group {
    display: flex;
    justify-content: space-between;

    .left {
      display: flex;

      button {
        margin-right: 10px;
      }

      .widget-type-info {
        align-self: center;
        font-size: 17px;
        margin: 0 10px;
        font-weight: bold;

        .type {
          color: #6200ea;
          font-size: 19px;
        }
      }
    }

    button {
      font-size: 18px;
      width: 100px;
    }
  }
`;
